import {featureIds} from './featureIds';
import $ = require('jquery');

interface FeatureConfig {
    enabled: number;
    payload: {};
}

declare var jimdoData: {
    features: {
        [featureLabel: string]: number|FeatureConfig};
};

function getFeature(featureLabel: string) {
    if (typeof jimdoData === 'undefined'
        || typeof jimdoData.features === 'undefined'
        || typeof jimdoData.features[featureLabel] === 'undefined'
    ) {
        return null;
    }
    return jimdoData.features[featureLabel];
}

let isEnabled = function(featureLabel: string) {
    let feature = getFeature(featureLabel);

    if (feature === null) {
        // feature not found, but I won't throw an Error for the sake of backward compatibility
        return null;
    }

    if (typeof feature === 'number') {
        return (feature === 1);
    } else {
        return feature.enabled === 1;
    }
};

let getPayload = function<T>(featureLabel: string) {
    let feature = getFeature(featureLabel);

    if (feature === null) {
        throw new Error('Feature ' + featureLabel + ' not found');
    }
    if (typeof feature === 'number') {
        return null;
    } else {
        return <T>feature.payload;
    }
};

let disableFeature = function(featureLabel: string) {
    if (isEnabled(featureLabel)) {
        let featureId = featureIds[featureLabel];
        if (!featureId) {
            throw new Error(`Invalid feature label '${featureLabel}'`);
        }
        return Promise.resolve<void>($.ajax({
            url: '/app/help/service/disable-feature/?id=' + featureId
        })).then(() => {
            jimdoData.features[featureLabel] = 0;
        });
    }
    // Already disabled
    return Promise.resolve();
};

let enableFeature = function(featureLabel: string) {
    if (!isEnabled(featureLabel)) {
        let featureId = featureIds[featureLabel];
        if (!featureId) {
            throw new Error(`Invalid feature label '${featureLabel}'`);
        }
        return Promise.resolve<void>($.ajax({
            url: '/app/help/service/enable-feature/?id=' + featureId
        })).then(() => {
            if (featureLabel === 'cipDisclaimer') {
                jimdoData.features[featureLabel] = {enabled: 1, payload: {acknowleged_at: 1}};
            } else {
                jimdoData.features[featureLabel] = 1;
            }
        });
    }
    // Already enabled
    return Promise.resolve();
};

interface Features {
    (featureLabel: string): boolean;
    getPayload<T>(featureLabel: string): T;
    disableFeature(featureLabel: string): Promise<void>;
    enableFeature(featureLabel: string): Promise<void>;
    isEnabled(featureLabel: string): boolean;
}

// exporting by default isEnabled for backward compatibility
let features = <Features>isEnabled;

// then adding new functions to it statically
features.getPayload = getPayload;
features.disableFeature = disableFeature;
features.enableFeature = enableFeature;
features.isEnabled = isEnabled;

//TODO: get rid of this hack and replace with proper exports
export = features;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/util/features.ts
 **/